/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UnitEconomicsTierRow interface.
 */
export function instanceOfUnitEconomicsTierRow(value) {
    if (!('costUsd' in value) || value['costUsd'] === undefined)
        return false;
    if (!('estimatedRevenuePln' in value) || value['estimatedRevenuePln'] === undefined)
        return false;
    if (!('generations' in value) || value['generations'] === undefined)
        return false;
    if (!('tokensIn' in value) || value['tokensIn'] === undefined)
        return false;
    if (!('tokensOut' in value) || value['tokensOut'] === undefined)
        return false;
    if (!('users' in value) || value['users'] === undefined)
        return false;
    return true;
}
export function UnitEconomicsTierRowFromJSON(json) {
    return UnitEconomicsTierRowFromJSONTyped(json, false);
}
export function UnitEconomicsTierRowFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'costUsd': json['costUsd'],
        'estimatedRevenuePln': json['estimatedRevenuePln'],
        'generations': json['generations'],
        'tokensIn': json['tokensIn'],
        'tokensOut': json['tokensOut'],
        'users': json['users'],
    };
}
export function UnitEconomicsTierRowToJSON(json) {
    return UnitEconomicsTierRowToJSONTyped(json, false);
}
export function UnitEconomicsTierRowToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'costUsd': value['costUsd'],
        'estimatedRevenuePln': value['estimatedRevenuePln'],
        'generations': value['generations'],
        'tokensIn': value['tokensIn'],
        'tokensOut': value['tokensOut'],
        'users': value['users'],
    };
}
